import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { ITheme } from '../../Models';

interface IFaqThemeWidgetProps {
    themes: ITheme[];
    currentThemeId: number;
    onClick: (id: number) => void;
    coloredFaq: boolean;
}

export class FaqThemeListWidget extends Component<IFaqThemeWidgetProps, any> {
    constructor(props: IFaqThemeWidgetProps) {
        super(props);
    }

    handleClick(themeId: number) {
        this.props.onClick(themeId);
    }

    render() {
        return (
            <div className="tab__filters">
                {this.props.themes.map((theme) => {
                    let borderSelected = {} as React.CSSProperties;
                    if (!this.props.coloredFaq) {
                        borderSelected =
                            theme.id === this.props.currentThemeId
                                ? ({
                                      border: '3px solid #002d5d',
                                  } as React.CSSProperties)
                                : ({
                                      border: '3px solid #f3f4f4',
                                  } as React.CSSProperties);
                    }
                    const themeClass =
                        theme.id === this.props.currentThemeId ? 'active ' : '';
                    return (
                        <div
                            key={'theme' + theme.id}
                            className={`filter_wrapper ${!this.props.coloredFaq ? 'col-lg-4 col-12' : ''}`}
                        >
                            <button
                                key={'theme' + theme.id}
                                className={themeClass}
                                style={borderSelected}
                                onClick={() => this.handleClick(theme.id)}
                            >
                                {theme.name}
                            </button>
                        </div>
                    );
                })}
            </div>
        );
    }
}

WidgetHelper.register(FaqThemeListWidget, 'faq-theme-list-widget');
